<template>
    <ui-modal id="add-job" :title="title" title-text="Preencha corretamente os dados da vaga." size="md">
        <form v-on:submit.prevent="save">
            <div class="msg" v-if="message">{{message}}</div>
            <div class="input-box">
                <input id="input-title" type="text" placeholder=" " v-model="form.title">
                <label for="input-title">
                    <span>Título:</span>
                </label>
            </div>
            <div class="textarea-box">
                <textarea id="input-description" placeholder=" " v-textarea-resize v-model="form.description"></textarea>
                <label for="input-description">
                    <span>Descrição da vaga:</span>
                </label>
            </div>
            <div class="textarea-box">
                <textarea id="input-responsibilities" placeholder=" " v-textarea-resize v-model="form.responsibilities"></textarea>
                <label for="input-responsibilities">
                    <span>Responsabilidades:</span>
                </label>
            </div>
            <div class="textarea-box">
                <textarea id="input-requirements" placeholder=" " v-textarea-resize v-model="form.requirements"></textarea>
                <label for="input-requirements">
                    <span>Exigências:</span>
                </label>
            </div>
            <div class="input-box">
                <input id="input-salary" type="text" placeholder=" " v-model="form.salary" v-money="form.salary">
                <label for="input-salary">
                    <span>Salário:</span>
                </label>
            </div>
            <div class="input-box input-select">
                <select id="input-regime" v-model="form.regime">
                    <option value="Carteira Assinada CLT" selected>Carteira Assinada CLT</option>
                    <option value="Contrato" selected>Contrato</option>
                </select>
                <label for="input-regime">
                    <span>Regime de Contratação</span>
                </label>
            </div>
            <div class="list-checkbox">
                <h3>Benefícios:</h3>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox" v-model="form.benefits" value="Plano de Saúde"> <span>Plano de Saúde</span>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox" v-model="form.benefits" value="Plano de Dentário"> <span> Plano de Dentário</span>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox" v-model="form.benefits" value="Vale Alimentação"> <span> Vale Alimentação</span>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox" v-model="form.benefits" value="Seguro de Vida"> <span> Seguro de Vida</span>
                        </label>
                    </li>
                </ul>
            </div>
            <div class="control">
                <button type="submit" :class="indicator">{{btnText}}</button>
            </div>
        </form>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components'
    import { jobs } from '@/services'
    import { textareaResize } from '@/directives'
    export default {
        components: { uiModal },
        directives: { textareaResize },
        props: {
            register: {}
        },
        data() {
            return {
                roles: [],
                message: '',
                load: false,
                title: 'Adicionar Vaga de Emprego',
                btnText: 'Publicar vaga',
                form: {
                    title: '',
                    description: '',
                    responsibilities: '',
                    requirements: '',
                    salary: '',
                    benefits: []
                }
            }
        },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        watch:{
            register(register){
                this.title = register ? 'Editar Vaga de Emprego' : 'Adicionar Vaga de Emprego'
                this.btnText = register ? 'Salvar alterações' : 'Publicar vaga'
                if(!register){
                    this.form = {
                        title: '',
                        description: '',
                        responsibilities: '',
                        requirements: '',
                        salary: '',
                        benefits: []
                    }
                }else{
                    this.form = JSON.parse(JSON.stringify(register));
                    this.form.benefits = this.form.benefits.split(',')
                }
                return register
            }
        },
        methods: {
            save(){
                this.load = true
                if(!this.register){
                    jobs.add(this.form).then( response => {
                        this.load = false
                        this.$root.$emit('add-item', response.data.row);
                        this.$root.$emit('modal-close', 'add-job');
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false
                    })
                }else{
                    delete this.form.index
                    jobs.update(this.form).then( response => {
                        this.load = false
                        response.data.row.index = this.register.index
                        this.$root.$emit('update-item', response.data.row);
                        this.$root.$emit('modal-close', 'add-job');
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false
                    })
                }
            }, 
        },
        created(){
            
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
